import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import config from "../config";
import CheckIcon from '../assets/icons/check_icon'

const Login = () => { 
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const response = await axios.post(`${config.BASE_URL}/api/v1/login`, {
        email,
        password,
      });

      localStorage.setItem("token", response.data.token);
      navigate("/dashboard");

    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="logo-section">
        <img src="bentex-logo.png" alt="Bentex Suits Logo" className="logo" />
      </div>
      <div className="login-container">
        <form className="login-form" onSubmit={handleLogin}>
          <h2>Login</h2>
          {error && <p className="error-message">{error}</p>}
          <div className="form-group">
            <input type="email" placeholder="Username or Email" className="input-field" value={email} onChange={(e) => setEmail(e.target.value)} required />
            <label htmlFor="Email">Username or Email</label>
          </div>
          <div className="form-group">
            <input type="password" placeholder="Password" className="input-field" value={password} onChange={(e) => setPassword(e.target.value)} required />
            <label htmlFor="password">Password</label>
          </div>
          <div className="form-footer">
            <div className='input_field'>
              <input type="checkbox" />
              <span className='checked_icon'>
                <CheckIcon />
              </span>
              <p>Remember me</p>
            </div>
            <div className="forgot-password">
              <span>*Forgot your password?</span>{" "}
              <a href="/reset">Reset Here</a>
            </div>
          </div>
          <button type="submit" className="login-button" disabled={loading}>
            {loading ? "Logging in..." : "Login"} <span>→</span>
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
